<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <ListEntities />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <ListExternalEmployees />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ListEntities from '@/views/entities/components/ListEntities'
import ListExternalEmployees from '@/views/entities/components/ListExternalEmployees'

export default {
  name: 'Home',
  components: { ListEntities, ListExternalEmployees },
}
</script>

<style lang="css" scoped>
:focus {
  outline: -webkit-focus-ring-color none !important;
}
</style>
